// src/pages/ReadyWebsitesPage.js
import React from 'react';
import ReadyWebsiteList from '../components/Website/ReadyWebsiteList';

const ReadyWebsitesPage = () => {
    return (
        <div>
            <ReadyWebsiteList />
        </div>
    );
};

export default ReadyWebsitesPage;